var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$userInfo
    ? _c(
        "div",
        [
          _c("app-detail-header", {
            attrs: {
              "show-toggle": true,
              "show-delete": false,
              "show-save": false,
              "show-cancel": _vm.checkFactorReceipt,
              "show-new": false,
              "show-print": true,
              "show-advance-receipt-entry": !_vm.checkFactorReceipt,
              "show-factor-invoice": !_vm.checkFactorReceipt,
              "show-factor-selected-invoice": _vm.checkFactorReceipt,
              "show-bank-un-deposited-funds": !_vm.checkFactorReceipt,
            },
            on: { appDetailHeaderButtonClicked: _vm.onHeaderButtonClicked },
          }),
          _c("div", { staticClass: "columns is-gapless" }, [
            _c(
              "div",
              { staticClass: "column is-narrow" },
              [
                _c("receipt-entry-list-side-menu", {
                  on: { filter: _vm.filterList, reset: _vm.resetList },
                  model: {
                    value: _vm.filter,
                    callback: function ($$v) {
                      _vm.filter = $$v
                    },
                    expression: "filter",
                  },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "column" }, [
              _c("div", { staticClass: "m-3" }, [
                _c(
                  "article",
                  { staticClass: "box" },
                  [
                    _c(
                      "bulma-table",
                      {
                        staticClass:
                          "table is-bordered is-striped is-narrow is-fullwidth",
                        attrs: {
                          columns: _vm.columns,
                          "page-index": _vm.filter.pageIndex,
                          "page-size": _vm.filter.pageSize,
                          "total-rows": _vm.totalRows,
                          "is-loading": _vm.isTableLoading,
                          "sort-column": _vm.filter.sortColumn,
                          "sort-order": _vm.filter.sortOrder,
                        },
                        on: { pageChanged: _vm.onPageChange, sort: _vm.sort },
                      },
                      [
                        _vm._l(
                          _vm.receiptEntrySummaries,
                          function (receiptentry, index) {
                            return _c(
                              "tr",
                              {
                                key: receiptentry.invoiceID,
                                class: {
                                  "is-selected": _vm.selectedRow === index,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.highlightSelected(index, $event)
                                  },
                                },
                              },
                              [
                                _vm.checkFactorReceipt
                                  ? _c(
                                      "td",
                                      {
                                        staticClass:
                                          "has-vertical-middle has-text-centered",
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: receiptentry.isChecked,
                                              expression:
                                                "receiptentry.isChecked",
                                            },
                                          ],
                                          staticClass: "is-checkradio is-info",
                                          class: {
                                            "has-background-color":
                                              receiptentry.isChecked,
                                          },
                                          attrs: {
                                            type: "checkbox",
                                            disabled:
                                              receiptentry.balance == 0
                                                ? true
                                                : false,
                                            id: `factor${index}`,
                                            name: `factor${index}`,
                                          },
                                          domProps: {
                                            checked: Array.isArray(
                                              receiptentry.isChecked
                                            )
                                              ? _vm._i(
                                                  receiptentry.isChecked,
                                                  null
                                                ) > -1
                                              : receiptentry.isChecked,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.selectFactorInv(
                                                receiptentry
                                              )
                                            },
                                            change: function ($event) {
                                              var $$a = receiptentry.isChecked,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    _vm.$set(
                                                      receiptentry,
                                                      "isChecked",
                                                      $$a.concat([$$v])
                                                    )
                                                } else {
                                                  $$i > -1 &&
                                                    _vm.$set(
                                                      receiptentry,
                                                      "isChecked",
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        )
                                                    )
                                                }
                                              } else {
                                                _vm.$set(
                                                  receiptentry,
                                                  "isChecked",
                                                  $$c
                                                )
                                              }
                                            },
                                          },
                                        }),
                                        _c("label", {
                                          attrs: {
                                            for: `factor${index}`,
                                            "data-label-empty": "",
                                          },
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                                _c("td", [
                                  _c(
                                    "a",
                                    {
                                      class: {
                                        "disable-click": _vm.showFactorInv,
                                      },
                                      attrs: {
                                        href: _vm.generateUrl(
                                          receiptentry.assetID
                                        ),
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.edit(
                                            receiptentry.assetID,
                                            $event
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(receiptentry.invoiceRef))]
                                  ),
                                ]),
                                _c("td", [
                                  _vm._v(_vm._s(receiptentry.customerName)),
                                ]),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$filters.formatDateTimezone(
                                        receiptentry.invoiceDate,
                                        _vm.$userInfo.locale
                                      )
                                    )
                                  ),
                                ]),
                                _c("td", { staticClass: "has-text-right" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$filters.formatNumber(
                                        receiptentry.balance,
                                        _vm.$userInfo.locale
                                      )
                                    )
                                  ),
                                ]),
                                _c("td", { staticClass: "has-text-right" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$filters.formatNumber(
                                          receiptentry.totalExGst,
                                          _vm.$userInfo.locale
                                        )
                                      )
                                    ),
                                  ]),
                                ]),
                                _c("td", { staticClass: "has-text-right" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$filters.formatNumber(
                                          receiptentry.gst,
                                          _vm.$userInfo.locale
                                        )
                                      )
                                    ),
                                  ]),
                                ]),
                                _c("td", { staticClass: "has-text-right" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$filters.formatNumber(
                                          receiptentry.totalIncGst,
                                          _vm.$userInfo.locale
                                        )
                                      )
                                    ),
                                  ]),
                                ]),
                                _c("td", { staticClass: "has-text-left" }, [
                                  _c("span", [
                                    _vm._v(_vm._s(receiptentry.quoteNo)),
                                  ]),
                                ]),
                                _vm.showAction
                                  ? _c(
                                      "td",
                                      { staticClass: "has-text-centered" },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "button is-primary is-small is-inverted tooltip",
                                            attrs: {
                                              href: _vm.generateUrl(
                                                receiptentry.assetID
                                              ),
                                              "data-tooltip": "Receipt Payment",
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                return _vm.edit(
                                                  receiptentry.assetID,
                                                  $event
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "icon is-medium" },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "mdi mdi-currency-usd mdi-24px",
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            )
                          }
                        ),
                        _c("template", { slot: "empty" }, [
                          _c("section", { staticClass: "section" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "content has-text-grey has-text-centered",
                              },
                              [
                                _c(
                                  "span",
                                  { attrs: { icon: "icon is-large" } },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "mdi mdi-48px mdi-emoticon-sad",
                                    }),
                                  ]
                                ),
                                _c("p", [_vm._v("Nothing")]),
                              ]
                            ),
                          ]),
                        ]),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
          _vm.isLoadAdvPaymentModalActive
            ? _c(
                "advance-receipt-modal",
                {
                  attrs: {
                    active: _vm.isLoadAdvPaymentModalActive,
                    "show-icon": false,
                  },
                  on: {
                    "update:active": function ($event) {
                      _vm.isLoadAdvPaymentModalActive = $event
                    },
                    close: function ($event) {
                      return _vm.closeModal()
                    },
                  },
                },
                [
                  _c(
                    "p",
                    { attrs: { slot: "text-title" }, slot: "text-title" },
                    [_vm._v("Advance Receipt Entry")]
                  ),
                ]
              )
            : _vm._e(),
          _c(
            "confirm-modal",
            {
              attrs: {
                active: _vm.isConfirmModalActive,
                "ok-text": "Yes",
                "cancel-text": "No",
              },
              on: {
                "update:active": function ($event) {
                  _vm.isConfirmModalActive = $event
                },
                ok: function ($event) {
                  return _vm.confirmModalCancel(true)
                },
                cancel: function ($event) {
                  return _vm.confirmModalCancel(false)
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Factor Invoice"),
              ]),
              _c(
                "p",
                { attrs: { slot: "text-content" }, slot: "text-content" },
                [
                  _vm._v(" You have selected "),
                  _c(
                    "span",
                    { staticClass: "has-text-primary has-text-weight-bold" },
                    [_vm._v(_vm._s(`${_vm.selectedFactorReceipts.length}`))]
                  ),
                  _vm._v(" unfactored invoices. Continue to go back? "),
                ]
              ),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }